// X-18 (audit 3 Nov 2026): one short date format. Intl's en-GB short month
// writes "Sept" (Node 22, recent browsers) while the hand-made formats write
// "Sep", so the event stepper said "17 Sept" next to "14 Sep" elsewhere.
// These use a fixed month list, the same on the server and in the browser.

export const MONTHS_SHORT = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"] as const;

const parts = (iso: string) => ({ y: Number(iso.slice(0, 4)), m: Number(iso.slice(5, 7)), d: Number(iso.slice(8, 10)) });

/** "7 Sep" from "2026-09-07" (or a longer ISO string). */
export function dayMonthShort(iso: string): string {
  const p = parts(iso);
  return `${p.d} ${MONTHS_SHORT[p.m - 1]}`;
}

/** "Tue 7 Sep" from "2026-09-07" (X-18: the fixed month list, never "Sept"). */
export function weekdayDayMonthShort(iso: string): string {
  const p = parts(iso);
  return `${WEEKDAYS_SHORT[new Date(Date.UTC(p.y, p.m - 1, p.d)).getUTCDay()]} ${p.d} ${MONTHS_SHORT[p.m - 1]}`;
}

export const WEEKDAYS_SHORT = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"] as const;

/** "Sep 2026" for a moment, in the browser's or server's own time zone. */
export const monthYearShortOf = (d: Date): string => `${MONTHS_SHORT[d.getMonth()]} ${d.getFullYear()}`;

/** "7 Sep, 14:05" for a moment, in the local time zone. */
export const dayMonthTimeOf = (d: Date): string => `${d.getDate()} ${MONTHS_SHORT[d.getMonth()]}, ${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;

/** "7 Sep 2026" from "2026-09-07". */
export function dayMonthYearShort(iso: string): string {
  const p = parts(iso);
  return `${p.d} ${MONTHS_SHORT[p.m - 1]} ${p.y}`;
}
